/**
 * Manufacturing Module Container
 * Routes and layout for the manufacturing management module.
 *
 * @author SAUBHAGYA Development Team
 * @since Epic 6
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { ManufacturingDashboard } from '@/pages/manufacturing/ManufacturingDashboard';
import { TransactionListPage } from '@/pages/manufacturing/TransactionListPage';
import { PaymentListPage } from '@/pages/manufacturing/PaymentListPage';
import { ProductionBatchListPage } from '@/pages/manufacturing/ProductionBatchListPage';
import { RawMaterialDeliveriesPage } from '@/pages/manufacturing/RawMaterialDeliveriesPage';
import { ManufacturingProfile } from '@/pages/manufacturing/ManufacturingProfile';
import ManufacturingLayout from './components/ManufacturingLayout';

export default function ManufacturingModule() {
  return (
    <Routes>
      <Route element={<ManufacturingLayout />}>
        {/* Default redirect to dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />

        {/* Dashboard */}
        <Route path="dashboard" element={<ManufacturingDashboard />} />

        {/* Transactions */}
        <Route path="transactions" element={<TransactionListPage />} />
        <Route path="transactions/new" element={<TransactionListPage />} />
        <Route path="transactions/:id" element={<TransactionListPage />} />

        {/* Production Batches */}
        <Route path="production" element={<ProductionBatchListPage />} />
        <Route path="production/batches" element={<ProductionBatchListPage />} />

        {/* Payments */}
        <Route path="payments" element={<PaymentListPage />} />

        {/* Raw Material Deliveries */}
        <Route path="raw-material-deliveries" element={<RawMaterialDeliveriesPage />} />
        <Route path="raw-material-deliveries/:id" element={<RawMaterialDeliveriesPage />} />

        {/* Profile */}
        <Route path="profile" element={<ManufacturingProfile />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
}
